import React from "react";

import Framework from "@beardeddevops/react.framework";
import {Objects, Parts, Types} from "components";
import API from "@beardeddevops/react.api";
import moment from "moment-timezone";
import {confirmAlert} from "react-confirm-alert";
import {Button, Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";
import UserRoles from "../../constants/UserRoles";
import {Tooltip} from "@material-ui/core";
import {isDirtySafe, setTimestamp} from "../../constants/Utilities";

/**
 *  @property {Customers_Object} state
 *  @property {object} model
 *  @property {Customers_Properties} model.properties
 *  @property {Customers_Is} model.is
 *  @property {Customers_Has} model.has
 */
export default class Customer extends Framework.Components.Object {
	constructor(props) {
		super(props, Types.Customers._name);
		this.redirect = this.props.baseUrl;
		this.customerLocationFormRef = React.createRef();
	}

	

	/**
	 * @param prevProps
	 * @param {Customers_Object} prevState
	 * @param snapshot
	 */
	componentDidUpdate(prevProps, prevState, snapshot) {
		super.componentDidUpdate(prevProps, prevState, snapshot);
		if (typeof this.props.updateName === 'function') {
			this.props.updateName(this.state.name);
		}
		if (typeof this.props.searchChange === 'function') {
			if (this.state.name !== prevState.name && prevProps === this.props && this.state.name !== null) {
				this.props.searchChange(this.state.name);
			}
			if (this.state.phone !== prevState.phone && prevProps === this.props && this.state.phone !== null) {
				this.props.searchChange(this.state.phone);
			}
			if (this.state.phone_alt !== prevState.phone_alt && prevProps === this.props && this.state.phone_alt !== null) {
				this.props.searchChange(this.state.phone_alt);
			}
			if (this.state.email !== prevState.email && prevProps === this.props && this.state.email !== null) {
				this.props.searchChange(this.state.email);
			}
		}
		//check if something has changed and if it has then update the timestamp used for delaying the idle modal
		const isDirty = isDirtySafe(prevState, this.state, ['name', 'phone', 'phone_alt', 'email', 'notes', 'referer', 'street_1', 'city', 'state', 'zip'])
		if (isDirty) {
			setTimestamp('lastSync')
		}
	}

	async handleSubmit(event, suppressToast = false, suppressProcess = false) {
		if ((!this.state.latitude || !this.state.longitude) && this.state.street_1) {
			this.setState({validateAddress: this.state.street_1 + ", " + this.state.city})
		}
		//timeout is to assure that the address is validated
		setTimeout(async () => {
			if (this.state.validateAddress === 'validated' || !this.state.street_1) {
				await super.handleSubmit(event, suppressToast, suppressProcess).then();
			} else if (!this.state.street_1) {
				API.Toast.info('Unable to validate the address, please double check that everything is correct.', {
					position: API.Toast.POSITION.TOP_CENTER
				});
			} else {
				API.Toast.info('Unable to validate the address, please double check that everything is correct.', {
					position: API.Toast.POSITION.TOP_CENTER
				});
			}
		}, 500)
	}

	handleCustomerLocationSave = async () => {
		let {current} = this.customerLocationFormRef;

		if (!current) return;

		try {
			await current.handleSubmit.call(current, null, true, false);
		} catch (e) {
			this.state.shouldBlockRedirect = true;
		}
	};


	handleCustomerLocationAfterSave = async (data) => {
		await this.setState({location: data});
		await this.props.submitTicket();
	};

	// noinspection JSUnusedLocalSymbols
	/**
	 * @param {Customers_Object} data
	 */
	loadSelfAfter(data) {
		if (typeof this.props.loadLocations === 'function') {
			this.props.loadLocations({
				locations: data.customers_locationss
			});
		}
	};

	ticketChangeRegion = (currentRegion, regionPkey) => {
		this.setState({region: regionPkey})
		this.props.changeRegion(currentRegion, regionPkey);
	}

	updateAddress = (address) => {
		this.state.street_1 = address.setStreet
		this.state.city = address.city
		this.state.state = address.state
		this.state.zip = address.zip
	}

	validateAddress = (lat, lng, validated) => {
		this.state.latitude = lat;
		this.state.longitude = lng;
		this.state.validateAddress = validated;
	}

	confirmBlacklist = () => {
		confirmAlert({
			title: this.state.blacklisted ? 'Confirm Blacklist Removal' : 'Confirm Blacklist',
			message: this.state.blacklisted ? 'Are you sure you want to remove this customer from the blacklist?' : 'Are you sure you want to blacklist this customer with these notes?',
			buttons: [
				{
					label: 'Yes',
					color: 'danger',
					onClick: async () => {
						let model = new API.BuildClass(Types.Customers._name, API.RequestType.UPDATE);
						model.object.pkey = this.state.pkey;
						try {
							await model.submit(this, 'POST_BLACKLIST');
						} catch (error) {
						}
						this.setState({toggleBlacklist: false})
						await this.loadSelf();
					}
				},
				{
					label: 'No',
					onClick: () => {
					}
				}
			]
		});
	}

	//Note: Doesn't need a form() function. Only ever used in a modal
	form = () => {
		/**
		 * @param {Customers_Properties} data
		 */
		let {properties} = this.model
		/**
		 * @type {Customers_Object} object
		 */
		let object = this.state
		let {loading} = this.state


		return (
			<div>
				<fieldset>
					<div className={"row"}>
						<div className={"col"}>

							<div className={'section-title'}>
								<h4 className="section-title">Contact Information</h4>
								{/*This is to reload the customer on the /dispatch page if needed*/}
								{this.props.forDispatch && this.state.pkey &&
									<div className={'flex-end text-right'}>
										<Button color="info" onClick={async () => {
											await this.loadSelf();
											if (this.props.forDispatch) {
												this.props.resetBlacklist(this.state.blacklisted)
											}
										}}>
											Reload Customer
										</Button>
									</div>}
							</div>

							<div className="form-group">
								<Tooltip title={this.props.forDispatch && this.state.blacklisted ? 'This customer is blacklisted. If a manager has confirmed it has been lifted, click "Reload Customer" above.' : ""}>
									<Framework.Elements.TextField
										property={properties.name}
										value={object.name}
										error={object.name_error ? object.name_error : this.props.forDispatch && this.state.blacklisted ? 'This customer is blacklisted.' : object.name_error}
										update={this.handleTextFieldPropertyUpdate}
										label={'Name'}
									/>
								</Tooltip>
							</div>

							<div className={'row'}>
								<div className={'col-6'}>
									<div className="form-group">
										<Framework.Elements.PhoneNumber
											property={properties.phone}
											value={object.phone}
											error={object.phone_error}
											update={this.handleTextFieldPropertyUpdate}
										/>
									</div>
								</div>
								<div className={'col-6'}>
									<div className="form-group">
										<Framework.Elements.PhoneNumber
											property={properties.phone_alt}
											value={object.phone_alt}
											error={object.phone_alt_error}
											update={this.handleTextFieldPropertyUpdate}
											label={'Alternate Phone'}
										/>
									</div>
								</div>
							</div>
							<div className="form-group">
								<Framework.Elements.EmailAddress
									property={properties.email}
									value={object.email}
									error={object.email_error}
									update={this.handleTextFieldPropertyUpdate}
								/>
							</div>
							{this.props.findFE && <div className={'form-group'}>
								<Objects.CustomerLocation
									ref={this.customerLocationFormRef}
									id={this.props.locationPkey}
									parent={this.props.id}
									hasModal={true}
									afterSave={this.handleCustomerLocationAfterSave}
									regionChange={this.ticketChangeRegion}
									searchChange={this.props.searchChange}
									findFE={true}
									condense={true}
									//object={this.props.location}
									updateAddress={!this.props.id ? this.updateAddress : undefined}
									validateAddress={!this.props.id ? this.validateAddress : undefined}
									addressToBeValidated={!this.props.id ? this.state.validateAddress : undefined}
									updateStreet={(street) => {
										this.setState({street_1: street})
									}}
									setAddress={this.props.setAddress}
								/>
							</div>}
							<div>
								<div className="form-group">
									<Framework.Elements.TextField
										property={properties.notes}
										value={object.notes}
										error={object.notes_error}
										update={this.handleTextFieldPropertyUpdate}
										multiline={4}
									/>
								</div>
								<div className={'row'}>
									<div className={'col-8'}>
										<div className="form-group">
											<Framework.Elements.TextField
												property={properties.referer}
												value={object.referer}
												error={object.referer_error}
												update={this.handleTextFieldPropertyUpdate}
											/>
										</div>
									</div>
									{!object.pkey || !this.props.forDispatch && <Tooltip title={"End User mentioned WEB10 discount"}>
										<div className={'col-4'}>
											<div className="form-group">
												<Framework.Elements.Checkbox
													value={object.web10}
													property={properties.web10}
													error={object.web10_error}
													update={() => this.setState({web10: !this.state.web10})}
													color="primary"
													label={"Web10"}
													disabled={!this.props.forDispatch}
												/>
											</div>
										</div>
									</Tooltip>}
								</div>
							</div>
							{!this.props.forDispatch && this.props.fromRoute && <div className={'row'}>
								<div className={'col-3'}>
									<div className="form-group">
										<Framework.Elements.Checkbox
											value={object.blacklisted}
											disabled={!this.props.roles || !this.props.roles.some(role => [UserRoles.Admin, UserRoles.Manager, UserRoles.Executive].includes(role))}
											property={properties.blacklisted}
											error={object.blacklisted_error}
											update={() => this.setState({toggleBlacklist: true})}
											color="primary"
											label={'Blacklisted' + (object.blacklisted_date ? (` at ${moment(object.blacklisted_date).format('MM/DD/YYYY h:mm A')}`) : '')}
										/>
									</div>
								</div>
							</div>}
							{object.blacklisted && !this.props.forDispatch && this.props.fromRoute && <div className="form-group">
								<Framework.Elements.TextField
									property={properties.blacklisted_reason}
									disabled={!this.props.roles || !this.props.roles.some(role => [UserRoles.Admin, UserRoles.Manager, UserRoles.Executive].includes(role))}
									value={object.blacklisted_reason}
									error={object.blacklisted_reason_error}
									update={this.handleTextFieldPropertyUpdate}
									multiline={4}
								/>
							</div>}
						</div>
					</div>
				</fieldset>
				<Modal
					isOpen={this.state.toggleBlacklist}
					toggle={() => {
						this.setState({toggleBlacklist: false})
					}}
					size={"lg"}
					backdrop={true}
					style={{opacity: 1}}>
					<ModalHeader>
						{this.state.blacklisted ? "Remove From Blacklist" : "Blacklist Reasoning"}
					</ModalHeader>
					<ModalBody style={{display: 'grid'}}>
						<b style={{marginBottom: 5}}>{this.state.blacklisted ? "This will allow the customer to be booked again." : "This will prevent this customer from being booked until the blacklist is lifted. Only managers and above can lift this."}</b>
						<div className="form-group">
							<Framework.Elements.TextField
								property={properties.blacklisted_reason}
								value={object.blacklisted_reason}
								error={object.blacklisted_reason_error}
								update={this.handleTextFieldPropertyUpdate}
								multiline={4}
							/>
						</div>
					</ModalBody>
					<ModalFooter>
						<Button color="secondary" onClick={() => {this.setState({toggleBlacklist: false, blacklisted_reason: null})}}>Close</Button>
						<Button color="danger" onClick={async () => {
							await this.confirmBlacklist();
						}}>{this.state.blacklisted ? "Confirm Removal From Blacklist" : "Confirm Blacklist"}</Button>
					</ModalFooter>
				</Modal>
				<Framework.Elements.LoadingSpinner isLoading={loading}/>
			</div>
		)
	}
}
